import styled from "styled-components";
import bg from "../../assets/images/maze-background-half.svg";
export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #fff;
  margin: ${(props) => props.margin || "auto"};
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: ${(props) => props.height};
    width: ${(props) => props.width};
    align-items: flex-start;
    justify-content: space-between;

    div.profile-left {
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        p.upload-prompt {
          text-transform: uppercase;
          font: italic bold 13px 'Roboto Condensed';
          text-align: center;
          cursor: pointer;
          margin-top: 8px;

          &:hover {color: #acff24;}
        }

        div.avatar-wrapper {
            width: 150px;
            height: 150px;
            border-radius: 50%;
            background-color: #2d2d2d;
            display: flex;
            align-items: center;
            justify-content: center;
            // flex-direction: column;

            i {font-size: 100px;
            color: #acff24;}
            img {height: 100px;}
        }
    }

    div.avatar-details {
        height: 160px;
        width: 70%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
        h1, h2{font: bold italic 22px 'Roboto Condensed'; text-transform: uppercase;}
        h2 { color: #acff24;}
    }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-color: ${(props) =>
    props.background ? "#1a1a1a" : "transparent"};
  width: ${(props) => props.width};
  min-width: 400px;
  height: ${(props) => props.height};
  padding: 1em 2em;
  border-radius: 5px;
  // background-image: url(${bg});
  margin-bottom: 2em;

  button.update-details {
    height: 36px;
    padding: 0 1em;
  }

  h1.details-heading {
    text-transform: uppercase;
    font: italic bold 22px "Roboto Condensed";
    text-align: center;
    color: ${(props) => (props.color ? props.color : "#fff")};
    width: 100%;
    text-align: left;
    margin-top: -2em;
  }
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-evenly;
  width: ${(props) => (props.width ? props.width : "100%")};
  margin-top: 1em;
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h3 {
    font: italic bold 18px "Roboto Condensed";
    text-transform: uppercase;
  }

  p {
    color: #ff0033;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: ${(props) => (props.width ? props.width : "100%")};

  p {
    font: italic bold 16px "Roboto Condensed";
    margin-bottom: -0.5em !important;
    text-transform: uppercase;
    color: #fff;
  }
`;

export const Title = styled.h2`
  font: normal normal 18px "Roboto Condensed";
  color: #fff;
  a span {
    color: #3ee9f7;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Profile/ProfilePage.styles.ts